import React from 'react';
export default function Terms() {
  return (
    <div className="page-wrapper" style={{paddingBottom:60}}>
      <div style={{background:'linear-gradient(135deg,#0D1421 0%,#0a2a4a 50%,#0D1421 100%)',padding:'60px 20px',textAlign:'center'}}>
        <div style={{fontSize:40,marginBottom:12}}>📋</div>
        <h1 style={{fontSize:34,fontWeight:800,marginBottom:12}}>الشروط والأحكام</h1>
        <p style={{color:'var(--color-text-muted)',fontSize:15}}>آخر تحديث: مايو 2026</p>
      </div>
      <div className="container" style={{maxWidth:800,paddingTop:48}}>
        {[
          {t:'1. قبول الشروط',d:'باستخدامك لمنصة SPORTIX، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على أي من هذه الشروط، يرجى عدم استخدام المنصة.'},
          {t:'2. استخدام المنصة',d:'يُسمح باستخدام المنصة للأغراض المشروعة فقط. يُحظر استخدام المنصة لنشر محتوى مضلل أو مسيء أو انتهاك حقوق الملكية الفكرية لأي طرف.'},
          {t:'3. حسابات المستخدمين',d:'أنت مسؤول عن الحفاظ على سرية بيانات حسابك. يجب أن تكون المعلومات التي تقدمها دقيقة وصحيحة. نحتفظ بالحق في تعليق أي حساب ينتهك هذه الشروط.'},
          {t:'4. المحتوى والملكية الفكرية',d:'جميع المحتويات المنشورة على المنصة من قبل SPORTIX محمية بحقوق الملكية الفكرية. المحتوى الذي تنشره أنت يظل ملكاً لك، لكنك تمنحنا ترخيصاً لعرضه على المنصة.'},
          {t:'5. إخلاء المسؤولية',d:'SPORTIX وسيط بين المحترفين الرياضيين والمؤسسات. لا نتحمل المسؤولية عن أي نزاعات تنشأ بين الأطراف بعد إتمام الاتصال عبر المنصة.'},
          {t:'6. التعديلات',d:'نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سيتم إخطارك بأي تغييرات جوهرية عبر البريد الإلكتروني المسجل لديك.'},
          {t:'7. القانون المطبق',d:'تخضع هذه الشروط لقوانين دولة الإمارات العربية المتحدة. أي نزاع يتم حله أمام المحاكم المختصة في إمارة دبي.'},
        ].map((s,i)=>(
          <div key={i} className="card" style={{padding:28,marginBottom:16}}>
            <h3 style={{fontSize:18,fontWeight:700,marginBottom:12,color:'var(--color-primary)'}}>{s.t}</h3>
            <p style={{color:'var(--color-text-muted)',lineHeight:1.9,fontSize:14}}>{s.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
